{
  "version": 1,
  "asset_id": "26e7a846-aee9-459b-91df-13d402d25ddd",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/26e7a846-aee9-459b-91df-13d402d25ddd/deliverables-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/26e7a846-aee9-459b-91df-13d402d25ddd/deliverables-1280.avif",
  "original_filename": "deliverables-1280.avif",
  "size": 44002,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:51Z"
}
